export default __webpack_public_path__ + "static/media/brokenClouds.b90094dc.jpg";